import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loaderActions } from "../../redux/slices/loadingSlice";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import confirmCancellationService from "../../services/confirmCancellationService";
import useCookiesCheck from "../../utils/useCookiesCheck";
import { useTranslation } from "react-i18next";

const FormCancellationData = () => {
  useCookiesCheck();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const booking = useAppSelector((state) => state.booking);
  const isAgency = booking.isAgencyBooking;
  const location = useLocation();
  const stateData: IReqDynamicCancellation = location.state.data;
  const [startDate, setStartDate] = useState<any>();
  const [zipCode, setZipCode] = useState("");
  const [agencyId, setAgencyId] = useState<string | null>();

  useEffect(() => {
    if (!isAgency) {
      setAgencyId(booking.agencyId);
    }
  }, []);

  const [cancellationConfirmed, setCancellationConfirmed] = useState(false);
  const { t } = useTranslation();

  const submitHandler = async (e: any) => {
    dispatch(loaderActions.showLoader());
    e.preventDefault();

    try {
      const response: IReqDynamicCancellation =
        await confirmCancellationService({
          orderNo: booking.bookingNumber,
          lastName: booking.bookingUsername,
          agencyId: agencyId || "",
          amount: stateData.data?.amount || "0",
          departureDate: startDate,
          postalCode: zipCode,
        });

      if (response.success) {
        navigate("/thanksMsg");
        dispatch(loaderActions.hideLoader());
      } else {
        dispatch(loaderActions.hideLoader());
        toast.error(response.message);
      }
    } catch (err: any) {
      toast.error("send fail");
      dispatch(loaderActions.hideLoader());
    }
  };

  return (
    <div className="cancellationPage" style={{ height: "800px" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-8">
            <form className="cancellationForm" onSubmit={submitHandler}>
              <div className="mb-3">
                <label className="form-label">
                  {t("other.bookingNumber")}*
                </label>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  placeholder=""
                  value={stateData.data?.orderNo}
                  readOnly
                />
              </div>

              <div className="mb-3">
                <label className="form-label"> {t("other.lastName")}*</label>
                <input
                  type="text"
                  className="form-control"
                  value={booking.bookingUsername}
                  disabled
                  readOnly
                />
              </div>

              {isAgency && (
                <div className="mb-3">
                  <label className="form-label">{t("other.agencyId")} *</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("other.engerAgencyId")}
                    required
                    onChange={(e) => setAgencyId(e.target.value)}
                  />
                </div>
              )}

                {!isAgency && (

                <div className="mb-3">
                  <label className="form-label">{t("other.postalCode")}*</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("other.postalCode")}
                    onChange={(e) => setZipCode(e.target.value)}
                  />
                </div>
                           )}

              <div className="mb-3">
                <label className="form-label d-block">
                  {t("other.travelDate")}*
                </label>

                <DatePicker
                  title="startTravelDate"
                  dateFormat="dd.MM.yyyy"
                  className="form-control"
                  selected={startDate}
                  placeholderText={t("other.travelDate")}
                  onChange={(date) => setStartDate(date)}
                  required
                />
              </div>

              <div className="mb-3">
                <div className="d-flex gap-2">
                  <input
                    type="checkbox"
                    className="flex-shrink-0"
                    checked={cancellationConfirmed}
                    onChange={(e) => setCancellationConfirmed(e.target.checked)}
                  />
                  <label className="form-label">
                    {t("other.cancellationConfirmation")}
                  </label>
                </div>
              </div>

              <button type="submit" className="btn btn-warning text-white">
                {t("other.cancelNow")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormCancellationData;
